import type { IAdvertiser } from '@/Interfaces/Advertiser.interface';
import type { IDbFirstPartySegment } from '@/Interfaces/Beeswax/FirstPartySegment.interface';
import type { IPixelFormData } from '@/Interfaces/Pixels/Pixel.interface';
import { IAbortSignalThunkArg } from '@/Interfaces/Slices/AsyncThunk.interface';
import { EVENTS_ENDPOINT, eventsWithIdEndpoint } from '@/constants/endpoints';
import { getSecondsInDays } from '@/helpers/dateFormatter';
import axios from 'axios';

const firstPartySegmentsUrl = '/pixels/segments';

//#region segments
interface ICreateSegmentPayload {
  advertiserId: IAdvertiser['id'];
  segmentName: string;
}

export const createSegment = async (
  segmentName: string,
  advertiserId: IAdvertiser['id'],
): Promise<IDbFirstPartySegment> => {
  const payload: ICreateSegmentPayload = {
    advertiserId,
    segmentName,
  };
  const response = await axios.post<IDbFirstPartySegment>(firstPartySegmentsUrl, payload);
  return response.data;
};

export const fetchSegments = async (payload: IAbortSignalThunkArg) => {
  const response = await axios.get(firstPartySegmentsUrl, {
    signal: payload?.signal,
  });
  return response.data;
};
//#endregion

//#region pixels
interface IPixelRequestData {
  name: string;
  advertiserId: number;
  value: number;
  clickWindow: number;
  viewWindow: number;
  segmentId?: number;
}

const getPostRequestBody = (formData: IPixelFormData): IPixelRequestData => {
  const { name, advertiser, segment, clickWindow, viewWindow } = formData;
  const { value: advertiserId } = advertiser;
  const { value: segmentId } = segment || {};

  const requestBody: IPixelRequestData = {
    name,
    advertiserId,
    value: 1,
    clickWindow: getSecondsInDays(clickWindow),
    viewWindow: getSecondsInDays(viewWindow),
  };

  if (segmentId) {
    requestBody.segmentId = segmentId;
  }

  return requestBody;
};

const getPutRequestBody = (formData: IPixelFormData): Partial<IPixelRequestData> => {
  const { clickWindow, viewWindow, name } = formData;
  const requestBody: Partial<IPixelRequestData> = {
    clickWindow: getSecondsInDays(clickWindow),
    viewWindow: getSecondsInDays(viewWindow),
    name,
  };

  return requestBody;
};

export const createPixel = (formData: IPixelFormData) => {
  return axios.post(EVENTS_ENDPOINT, getPostRequestBody(formData));
};

export const updatePixel = (formData: IPixelFormData) => {
  return axios.put(eventsWithIdEndpoint(formData.id!), getPutRequestBody(formData));
};
//#endregion
